import axios from "axios";
import React, { useEffect, useState } from "react";
import BlockUi from "react-block-ui";
import Select from "react-select";

import { JdsButton } from "../../../components/jds/JdsButton";
import { jdsSelectProps } from "../../../components/jds/selectProps";
import "../../../components/jds/jds.css";
import "../addCoupons.css";
import { INSTALLLMENTS } from "./constants";

// Rótulo acima do campo; obrigatório leva asterisco vermelho depois do texto.
const Label = ({ required, children, ...rest }) => (
  <label {...rest}>
    {children}
    {required && (
      <span className="text-danger" aria-hidden="true">
        {" "}*
      </span>
    )}
  </label>
);

// Erro abaixo do campo.
const FieldError = ({ show, children }) =>
  show ? <div className="invalid-feedback d-block">{children}</div> : null;

export default function Step1(props) {
  const [isLoading,setIsLoading] = useState(true);
  const [featureGroups,setFeatureGroups] = useState({});
  const [displayAmount, setDisplayAmount] = useState("");
  const [displayOldAmount, setDisplayOldAmount] = useState("");

  const loadFeatureGroups = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/feature_groups?page_size=999999`
    );
    let featureGroups = response.data.data.data;
    setFeatureGroups(featureGroups);
    setIsLoading(false);
  };

  useEffect(() => {
    loadFeatureGroups();
  }, []);
    
  const formatToCurrency = (value) => {
    const number = Number.parseFloat(value);
    return number.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  const handleAmountChange = (e) => {
    let { value } = e.target;
    setDisplayAmount(value);
  };

  const handleOldAmountChange = (e) => {
    let { value } = e.target;
    setDisplayOldAmount(value);
  };

  const handleAmountBlur = () => {
    let numericValue = displayAmount.replace(/[^\d,]/g, "").replace(",", ".");
    numericValue = parseFloat(numericValue) || 0;
    
    const formattedValue = formatToCurrency(numericValue);
    
    setDisplayAmount(formattedValue);
    props.formik.setFieldValue("amount", numericValue);
  };

  const handleOldAmountBlur = () => {
    let numericValue = displayOldAmount.replace(/[^\d,]/g, "").replace(",", ".");
    numericValue = parseFloat(numericValue) || 0;
    
    const formattedValue = formatToCurrency(numericValue);
    
    setDisplayOldAmount(formattedValue);
    props.formik.setFieldValue("old_amount", numericValue);
  };

  useEffect(() => {
    if (!isNaN(props.formik.values.amount)) {
      const formattedValue = formatToCurrency(props.formik.values.amount);
      setDisplayAmount(formattedValue);
    }
  }, [props.formik.values.amount]);

  useEffect(() => {
    if (!isNaN(props.formik.values.old_amount)) {
      const formattedValue = formatToCurrency(props.formik.values.old_amount);
      setDisplayOldAmount(formattedValue);
    }
  }, [props.formik.values.old_amount]);

  const formik = props.formik;
  const isEdit = Boolean(props.id);
  const hasError = name => Boolean(formik.errors[name] && formik.touched[name]);
  const selectClass = name =>
    "acp-select" + (hasError(name) ? " is-invalid" : "");
  const inputClass = name =>
    "form-control" + (hasError(name) ? " is-invalid" : "");

  return (
    <BlockUi tag="div" blocking={formik.isSubmitting}>
      <h1 className="jds-title-lg acp-title">
        {isEdit ? "Editar cupom" : "Criar cupom"}
      </h1>
      {isEdit && (
        <div className="jds-notice" role="note">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            style={{ flexShrink: 0, marginTop: "var(--space-4)" }}
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 11v6M12 7.5v.5" />
          </svg>
          <div>
            <strong className="acp-notice-title">
              Modo edição: você está alterando um cupom já cadastrado.
            </strong>
            Revise os dados antes de salvar.
            <ul className="acp-notice-list">
              <li>
                Para cobrar outro valor, o caminho recomendado é{" "}
                <strong>criar um plano/cupom novo</strong>, conforme a
                estratégia comercial da operação.
              </li>
              <li>
                <strong>Os demais atributos</strong> do plano podem ser{" "}
                <strong>alterados normalmente</strong> aqui.
              </li>
            </ul>
          </div>
        </div>
      )}
      <div className="jds-card">
        <section className="acp-section">
          <h2 className="jds-title-sm acp-section-title">Dados do cupom</h2>
          <div className="acp-grid">
            <div className="form-group">
              <Label htmlFor="description" required>
                Nome
              </Label>
              <input
                id="description"
                type="text"
                name="description"
                className={inputClass("description")}
                value={formik.values.description}
                onChange={formik.handleChange}
              />
              <FieldError show={hasError("description")}>
                {formik.errors.description}
              </FieldError>
            </div>
            <div className="form-group">
              <Label htmlFor="coupom" required>
                Código do cupom
              </Label>
              <input
                id="coupom"
                type="text"
                name="coupom"
                className={inputClass("coupom")}
                value={formik.values.coupom}
                onChange={formik.handleChange}
              />
              <FieldError show={hasError("coupom")}>
                {formik.errors.coupom}
              </FieldError>
            </div>
            <div className="form-group">
              <Label htmlFor="subtitle" required>
                Descrição
              </Label>
              <textarea
                id="subtitle"
                name="subtitle"
                className={inputClass("subtitle")}
                value={formik.values.subtitle}
                onChange={formik.handleChange}
                rows={3}
              ></textarea>
              <FieldError show={hasError("subtitle")}>
                {formik.errors.subtitle}
              </FieldError>
            </div>
            <div className="form-group">
              <Label htmlFor="feature_group_id" required>
                Grupo de planos
              </Label>
              {!isLoading ? (
                <Select
                  {...jdsSelectProps}
                  inputId="feature_group_id"
                  name="feature_group_id"
                  isSearchable={true}
                  isClearable={true}
                  options={featureGroups}
                  className={selectClass("feature_group_id")}
                  onChange={option => {
                    formik.setFieldValue("feature_group_id", option.id);
                  }}
                  value={featureGroups.find(
                    option => option.id === formik.values.feature_group_id
                  )}
                  placeholder="Selecione"
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                  noOptionsMessage={() => <span>Sem resultados.</span>}
                />
              ) : null}
              <FieldError show={hasError("feature_group_id")}>
                {formik.errors.feature_group_id}
              </FieldError>
            </div>
          </div>
        </section>

        <section className="acp-section">
          <h2 className="jds-title-sm acp-section-title">Valores</h2>
          <div className="acp-grid">
            <div className="form-group">
              <Label htmlFor="amount" required>
                Valor do plano
              </Label>
              <input
                id="amount"
                type="text"
                name="amount"
                disabled={isEdit}
                className={inputClass("amount")}
                value={displayAmount}
                onChange={handleAmountChange}
                onBlur={handleAmountBlur}
              />
              <FieldError show={hasError("amount")}>
                {formik.errors.amount}
              </FieldError>
            </div>
            <div className="form-group">
              <Label htmlFor="old_amount" required>
                Valor do plano sem desconto
              </Label>
              <input
                id="old_amount"
                type="text"
                name="old_amount"
                className={inputClass("old_amount")}
                value={displayOldAmount}
                onChange={handleOldAmountChange}
                onBlur={handleOldAmountBlur}
              />
              <FieldError show={hasError("old_amount")}>
                {formik.errors.old_amount}
              </FieldError>
            </div>
            <div className="form-group">
              <Label htmlFor="installments" required>
                Parcelas
              </Label>
              <Select
                {...jdsSelectProps}
                inputId="installments"
                name="installments"
                isSearchable={true}
                isClearable={true}
                options={INSTALLLMENTS}
                className={selectClass("installments")}
                onChange={option => {
                  formik.setFieldValue(
                    "installments",
                    option ? option.value : ""
                  );
                }}
                value={INSTALLLMENTS.find(
                  option => option.value === formik.values.installments || ""
                )}
                placeholder="Selecione"
                getOptionLabel={option => option.label}
                getOptionValue={option => option.value}
                noOptionsMessage={() => <span>Sem resultados.</span>}
              />
              <FieldError show={hasError("installments")}>
                {formik.errors.installments}
              </FieldError>
            </div>
          </div>
        </section>

        <section className="acp-section">
          <h2 className="jds-title-sm acp-section-title">
            Vigência e condições
          </h2>
          <div className="acp-grid">
            <div className="form-group">
              <Label htmlFor="valid_until" required>
                Validade do cupom
              </Label>
              <input
                id="valid_until"
                type="date"
                name="valid_until"
                className={inputClass("valid_until")}
                value={formik.values.valid_until}
                onChange={formik.handleChange}
              />
              <FieldError show={hasError("valid_until")}>
                {formik.errors.valid_until}
              </FieldError>
            </div>
            <div className="form-group">
              <Label htmlFor="max_redeems">Máximo de resgates</Label>
              <input
                id="max_redeems"
                type="number"
                name="max_redeems"
                className={inputClass("max_redeems")}
                value={formik.values.max_redeems}
                onChange={formik.handleChange}
              />
              <FieldError show={hasError("max_redeems")}>
                {formik.errors.max_redeems}
              </FieldError>
            </div>
            <div className="form-group">
              <Label htmlFor="periodicity" required>
                Duração (em dias)
              </Label>
              <input
                id="periodicity"
                type="number"
                name="periodicity"
                className={inputClass("periodicity")}
                value={formik.values.periodicity}
                onChange={formik.handleChange}
              />
              <FieldError show={hasError("periodicity")}>
                {formik.errors.periodicity}
              </FieldError>
            </div>
            <div className="form-group">
              <Label htmlFor="trial_days" required>
                Dias de trial
              </Label>
              <input
                id="trial_days"
                type="number"
                name="trial_days"
                className={inputClass("trial_days")}
                value={formik.values.trial_days}
                onChange={formik.handleChange}
              />
              <FieldError show={hasError("trial_days")}>
                {formik.errors.trial_days}
              </FieldError>
            </div>
            <div className="form-group">
              <Label id="upfront_label" required>
                Requisitar cartão no checkout?
              </Label>
              <div
                className="acp-radios"
                role="radiogroup"
                aria-labelledby="upfront_label"
              >
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="upfront_credit_card_required"
                    id="upfront_payment_yes"
                    onChange={() =>
                      formik.setFieldValue("upfront_credit_card_required", true)
                    }
                    checked={formik.values.upfront_credit_card_required === true}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="upfront_payment_yes"
                  >
                    Sim
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="upfront_credit_card_required"
                    id="upfront_payment_no"
                    onChange={() =>
                      formik.setFieldValue("upfront_credit_card_required", false)
                    }
                    checked={
                      formik.values.upfront_credit_card_required === false
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor="upfront_payment_no"
                  >
                    Não
                  </label>
                </div>
              </div>
              <FieldError show={hasError("upfront_credit_card_required")}>
                {formik.errors.upfront_credit_card_required}
              </FieldError>
            </div>
          </div>
        </section>

        <div className="acp-actions">
          <JdsButton onClick={formik.handleSubmit}>Salvar cupom</JdsButton>
        </div>
      </div>
    </BlockUi>
  );
}
